import { BaseHandler } from "../../../../infrastructure/base-handlers";
import { translate } from "../../../../localization";
import { removeErrorHistoryItem } from "../actions";
import { HandleHistoryItemsAddError } from "./request";

export class HandleHistoryItemsAddErrorHandler extends BaseHandler {
  async handle(payload: HandleHistoryItemsAddError) {
    try {
      const entityIdsWithError = payload.entities.map((error) => error.entityId);

      await this.dispatchRemoveErrorItems(entityIdsWithError);

      this.api.broker.publish(this.api.broker.events.activityHistory.errorLoadingData, entityIdsWithError);
    } catch (e) {
      this.api.notificationService.error(translate("error.errorToRefresh"));
    }
  }

  private async dispatchRemoveErrorItems(entityIds: string[]) {
    for (const entityId of entityIds) {
      this.store.dispatch(removeErrorHistoryItem(entityId));
    }
  }
}
